import { render, staticRenderFns } from "./LiefengCascaderTree.vue?vue&type=template&id=4b24c8b8&scoped=true&"
import script from "./LiefengCascaderTree.vue?vue&type=script&lang=js&"
export * from "./LiefengCascaderTree.vue?vue&type=script&lang=js&"
import style0 from "./LiefengCascaderTree.vue?vue&type=style&index=0&id=4b24c8b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24c8b8",
  null
  
)

export default component.exports